module.exports = __webpack_public_path__ + "static/media/dashboard-dashboard.10b60fdf.svg";